module.exports = __webpack_public_path__ + "assets/images/Rotina Personalizada.2c39fad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/icons/Rotina Personalizada.png
// module id = 794
// module chunks = 1